import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';
import user from './user';
import menu from './menu';
import transaksi from './transaksi';
import umkm from './umkm';
import satuankerja from './satuankerja';
import rencanabelanja from './rencanabelanja';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    user,
    menu,
    umkm,
    transaksi,
    satuankerja,
    rencanabelanja,
  },
  strict: process.env.DEV,
});
